import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotTollRatesApiMeta } from "../apiMeta";
import {
  type TollTripInfoInput,
  tollTripInfoInputSchema,
} from "./shared/tollTripInfo.input";
import {
  type TollTripInfo,
  tollTripInfoSchema,
} from "./shared/tollTripInfo.output";

/**
 * Metadata for the fetchTollTripInfo endpoint
 */
export const tollTripInfoMeta = {
  functionName: "fetchTollTripInfo",
  endpoint: "/getTollTripInfoAsJson",
  inputSchema: tollTripInfoInputSchema,
  outputSchema: tollTripInfoSchema.array(),
  sampleParams: {},
  endpointDescription: "List trip information for all toll trips statewide.",
} satisfies EndpointMeta<TollTripInfoInput, TollTripInfo[]>;

/**
 * Fetch function for retrieving trip information for all toll trips statewide
 */
const { fetch, useHook } = createFetchAndHook<
  TollTripInfoInput,
  TollTripInfo[]
>({
  api: wsdotTollRatesApiMeta,
  endpoint: tollTripInfoMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/tollTripInfo.endpoints").tollTripInfoGroup.cacheStrategy,
});

/**
 * Fetch function for retrieving trip information for all toll trips statewide
 */
export const fetchTollTripInfo: FetchFactory<
  TollTripInfoInput,
  TollTripInfo[]
> = fetch;

/**
 * React Query hook for retrieving trip information for all toll trips statewide
 */
export const useTollTripInfo: HookFactory<TollTripInfoInput, TollTripInfo[]> =
  useHook;
